import React, { Component } from 'react';
import PopUp from '../../../commonModules/interface/PopUp';
import { TableRow, TableCell, Grid, Table, TableHead, TableBody, Box, Card } from '@material-ui/core';
import { ReportProblemRounded } from '@material-ui/icons';
import { TableLayout } from '../../Menu/Stock/containers/Layout';

class ConfirmMatch extends Component {
    state = {  }

    displayFields(prod){
        const match = {
            "Nom":prod.name,
            "Marque":prod.marque,
            "Référence":prod.ref,
            "Type":prod.type,
            // "Prix HT":prod.prix_venteHT,
            // "Prix TTC":prod.prix_venteTTC,
            "Garantie (Années)":prod.garantie,

            "Poids (Kg)":prod.poids,   
            "Largeur (mm)":prod.largeur,   
            "Longueur (mm)":prod.longueur,   
            "Hauteur (mm)":prod.hauteur, 

            "Auto décharge": prod.bat_auto_decharge,
            "Capacité_Max(Ah)":prod.bat_max_capacity,
            "Type de batterie" :prod.bat_type,
            "Tension (V)":prod.bat_tension,
            "Nb cycles":prod.bat_nb_cycles,
            "Nb cycles à  30% de DOD":prod.bat_nb_cycles30,
            "Nb cycles à  50% de DOD":prod.bat_nb_cycles50,
            "Nb cycles à  80% de DOD":prod.bat_nb_cycles80,
            "Rendement énergétique (%)":prod.bat_rendement,            
            "Température d'exploitation":prod.bat_temperature,
            "Puissance(W)":prod.pan_puissance,            
            "Cellules (select)":prod.pan_cell,
            "Tension(Voc)" :prod.pan_tension,
            "Courant(Ioc)":prod.pan_courant,
            "Tension(Voc)" :prod.pan_tensionVoc,
            "Courant(Ioc)":prod.pan_courantIoc,
            "Tension(Vmpp)" :prod.pan_tensionVmpp,
            "Courant(Impp)":prod.pan_courantImpp,
            "Hauteur(mm)":prod.pan_height,
            "Largeur(mm)":prod.pan_width,
            "Profondeur(mm)":prod.pan_profondeur,
            "Rendement(%)":prod.pan_rendement,
            "Nombre de Conducteurs ":prod.cab_nb_conducteurs,
            "Section des conducteurs":prod.cab_section,
            "Type de conduits":prod.cab_type,
            "Tension de charge 'absorption'":prod.conv_absorption,
            "Courant de de charge de batterie de service (A)":prod.conv_courant_service,
            "Courant de de charge de batterie de démarrage (A)":prod.conv_courant_start,
            "Efficacité maximale":prod.conv_eff_max,
            "Tension de charge 'float' (VCC)":prod.conv_float,
            "Puissance de sortie (VA) ":prod.conv_puissance,
            "Puissance à 25°C (W) ":prod.conv_puissance25,
            "Puissance à 40°C (W) ":prod.conv_puissance40,
            "Puissance à 65°C (W)":prod.conv_puissance65,
            "Puissance crête":prod.conv_puissance_crete,
            "Type de signal":prod.conv_signal,
            "Puissance de sortie continue à 25°C (W)":prod.conv_sortie25,
            "Puissance de sortie continue à 40°C (W)":prod.conv_sortie40,
            "Tension entrée":prod.conv_tension,
            "Plage de tension d'entrée (VDC) max":prod.conv_tension_max,
            "Plage de tension d'entrée (VDC) min":prod.conv_tension_min,
            "Tension sortie nominale":prod.conv_tension_sortie,
            "Courant de Sortie Max":prod.conv_MPPT_courant_sortie,
            "Tension PV Max":prod.conv_MPPT_tensionPV_max,
            "Puissance PV Max":prod.conv_MPPT_puissancePV_max,

            "Fonctionnement en triphasé":prod.conv_triphase,
            "Flux Lumineux (lm)":prod.lam_flux,
            "Puissance(W)":prod.lam_puissance,
            "Puissance(W)":prod.pomp_puissance,
            "Tension d'alimentation":prod.lam_tension,
            "Affichage":prod.reg_affichage,
            "Courant de charge nominal (V)":prod.reg_courant,
            "Puissance nominale PV 12V ":prod.reg_puissance_pv12,
            "Puissance nominale PV 24V ":prod.reg_puissance_pv24,
            "Puissance nominale PV 48V ":prod.reg_puissance_pv48,
            "Tension PV maximale en circuit ouvert":prod.reg_tension_max,
            "Type de Régulateur":prod.reg_type,
            "Type Equipement":prod.men_type,
            "Puissance à vide (W)":prod.tv_puissance_vide,
            "Puissance en Fonctionnement":prod.tv_puissance_fonc,
            "Taille (pouces)":prod.tv_taille,
            "Puissance (W)":prod.vent_puissance,
            "Autres":prod.men_infos,            
            "Description":prod.desc,            
        }
        
        return Object.keys(match).map((field, i) => {            
            if( match[field] ) {
                if( Array.isArray(match[field]) ){
                    match[field].sort( (a, b) => {
                        return a - b;
                    })
                    return(  
                        <TableRow key={i}>
                            <TableCell>{field} :</TableCell><TableCell>{match[field].join('/')}</TableCell>
                        </TableRow>
                    )
                } else {
                    return(  
                        <TableRow key={i}>
                            <TableCell>{field} :</TableCell><TableCell>{match[field]}</TableCell>
                        </TableRow>
                    )
                }
            }
            
        })
    }

    render() {
        const { dest_product, src_product } = this.props;
        return (
            <Box>
                <PopUp
                    title="Confirmer l'association"
                    block={true}
                    close={this.props.handleClose}
                    submitAction={this.props.handleSubmit}
                    submitTitle="Confirmer"
                    disabledSubmit={this.props.loading}
                >
                    {(src_product.type !== dest_product.type || src_product.marque !== dest_product.marque) &&
                        <p className="c-red text-center" style={{ fontWeight: "600", fontSize: "16px", color: "red"}}>
                            <ReportProblemRounded color="error" /> Attention ces produits semblent différents
                        </p>
                    }
                    <Grid container spacing={2}>
                        <Grid item sm={12} md={6}>
                            <Card>
                                <TableLayout>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={2}>Compte Actuel</TableCell> 
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.displayFields(src_product)}
                                    </TableBody>
                                </TableLayout>
                            </Card>
                        </Grid>
                        <Grid item sm={12} md={6}>
                            <Card>
                                <TableLayout>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={2}>Compte Destinataire</TableCell> 
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.displayFields(dest_product)}
                                    </TableBody>
                                </TableLayout>
                            </Card>
                        </Grid>
                    </Grid>
                    {/* <div>
                        <button className="btn btn-info" onClick={this.props.handleSubmit}>
                            Confirmer
                        </button>
                    </div> */}
                </PopUp>
            </Box>
        );
    }
}

export default ConfirmMatch;